export const NO_COMPLETE_PERMISSION_MSG =
  'Only admins, the author of the task, and users assigned to the task are allowed to complete this task.';
export const NO_DELETE_PERMISSION_MSG =
  'Only admins and the author of the task can delete a task';
